import styles from './TextArea.module.css';
import attentionIcon from 'assets/svg/attention-01.svg';

import { forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';

const COMPONENT_NAME = 'TextArea'; // Название компонента для использования в логах

const COLOR_MAP = {
  primary: 'var(--color-brand)',
  accent: 'var(--text-primary-brand)',
};

const ALLOWED_VARIANTS = ['default', 'outlined', 'flat'];

const TextArea = forwardRef(
  (
    {
      className = '',
      label = '',
      placeholder = '',
      value = '',
      required = false,
      isFormValidate = false,
      onChange,
      name = undefined,
      hideErrorBlock = false,
      errorMessage = undefined,
    },
    ref,
  ) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event) => {
      const inputValue = event.target.value;
      setInputValue(inputValue);
      event.stopPropagation();
      onChange && onChange(inputValue);
    };

    useEffect(() => {
      setInputValue(value);
    }, [value]);

    return (
      <div className={clsx(className, styles.textAreaContainer)}>
        <div className={styles.formContainer}>
          {label && <div className={styles.label}>{label}</div>}
          <textarea
            name={name}
            className={styles.textarea}
            onChange={handleChange}
            onKeyUp={handleChange}
            defaultValue={inputValue}
            placeholder={placeholder}
          />
        </div>

        {!hideErrorBlock && (
          <div className={styles.dataErrorBlock}>
            {required && !value?.trim() && isFormValidate && (
              <>
                <img src={attentionIcon} alt={'attention'} />
                <div className={styles.dataError}>
                  {errorMessage?.message || 'Поле обязательно для заполнения'}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  },
);

export default TextArea;
